import { TRANSACTION_HISTORY, TRANSACTION_HISTORY_FILTER, TRANSACTION_HISTORY_SEARCH, TRANSACTION_HISTORY_SORT, TRANSACTION_HISTORY_EDITABLE, TRANSACTION_HISTORY_ALL_TXNS_ERROR, TRANSACTION_HISTORY_ALL_TXNS_LOADER, TRANSACTION_HISTORY_ALL_TXNS, TRANSACTION_HISTORY_ALL_TXNS_HIDE_ERROR, } from "@frameworks/web/redux/interfaces/Reports/iTransactionHistory";
import { combineReducers } from "redux";
import commonOnePlatFormReducer from "@frameworks/web/redux/reducers/common/commonReducer";
const initData = {
    transactionHistory: {
        totalRecords: 0,
        numberOfPages: 0,
        pageSize: 0,
        transactionList: [],
    },
    SearchData: "",
    FilterData: new Map(),
    SortData: {
        sortState: { list: [] },
        sortRecord: {},
    },
    editableTxns: [],
    allTransactionHistory: {
        totalRecords: 0,
        numberOfPages: 0,
        pageSize: 0,
        transactionList: [],
    },
    allTxnLoader: false,
    allTxnError: {
        error: undefined,
        isOpen: false,
    },
};
const TransactionHistoryReducer = (state = initData, action) => {
    switch (action.type) {
        case TRANSACTION_HISTORY:
            return Object.assign(Object.assign({}, state), { transactionHistory: action.payload.transactionHistory });
        case TRANSACTION_HISTORY_FILTER:
            return Object.assign(Object.assign({}, state), { FilterData: action.payload.FilterData });
        case TRANSACTION_HISTORY_SEARCH:
            return Object.assign(Object.assign({}, state), { SearchData: action.payload.SearchData });
        case TRANSACTION_HISTORY_SORT:
            return Object.assign(Object.assign({}, state), { SortData: action.payload.SortData });
        case TRANSACTION_HISTORY_EDITABLE:
            return Object.assign(Object.assign({}, state), { editableTxns: action.payload.editableTxns });
        case TRANSACTION_HISTORY_ALL_TXNS:
            return Object.assign(Object.assign({}, state), { allTransactionHistory: action.payload.allTransactionHistory });
        case TRANSACTION_HISTORY_ALL_TXNS_LOADER:
            return Object.assign(Object.assign({}, state), { allTxnLoader: action.payload.allTxnLoader });
        case TRANSACTION_HISTORY_ALL_TXNS_ERROR:
            return Object.assign(Object.assign({}, state), { allTxnError: action.payload.allTxnError });
        case TRANSACTION_HISTORY_ALL_TXNS_HIDE_ERROR:
            return Object.assign(Object.assign({}, state), { allTxnError: initData.allTxnError });
        default:
            return Object.assign({}, state);
    }
};
export default combineReducers({
    reducersData: TransactionHistoryReducer,
    commonData: commonOnePlatFormReducer,
});
